import { render, staticRenderFns } from "./upgrade.vue?vue&type=template&id=50b380b6&scoped=true&"
var script = {}
import style0 from "./upgrade.vue?vue&type=style&index=0&id=50b380b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b380b6",
  null
  
)

export default component.exports